import React, { useState } from 'react';

const PasswordTab: React.FC = () => {
    const [editMode, setEditMode] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            alert('Пароли не совпадают');
            return;
        }
        console.log('Новый пароль:', password);
        // TODO: Отправка на сервер
        setEditMode(false);
    };

    return (
        <div className="profile-page profile-page_password">
            <div className="profile-page__inner">
                <div className="profile-page__content-wrapper">
                    <header className="profile-page__header">
                        <h1 className="title profile-page__title">Пароль</h1>
                        <p className="profile-page__description">Надежный пароль помогает защитить ваш аккаунт</p>
                    </header>

                    {!editMode ? (
                        <div className="profile-page__content">
                            <p className="input-label">Ваш пароль</p>
                            <p style={{ fontSize: '2.5rem', letterSpacing: '0.3rem', color: 'black' }}>••••••••</p>
                            <button
                                type="button"
                                className="profile-page__edit-link profile-page-edit-link under"
                                onClick={() => setEditMode(true)}
                            >
                                Сменить
                            </button>
                        </div>
                    ) : (
                        <form style={{ margin: '0', textAlign: "start"}} className="form profile-page__form bionmax_account_password_edit_form" onSubmit={handleSubmit}>
                            <fieldset className="form__fields" >
                                <div className="">
                                    <div style={{ paddingLeft: '0'}} className="form__col">
                                        <label className="input__label input-label">Новый пароль</label>
                                        <label className="text-input">
                                            <input
                                                className="text-input__input"
                                                placeholder="Придумайте пароль"
                                                type={showPassword ? 'text' : 'password'}
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                            <div className="text-input__control">
                                                <button
                                                    type="button"
                                                    className="text-input__icon text-input__password-toggle"
                                                    onClick={() => setShowPassword((v) => !v)}
                                                >
                                                    <svg className="svg-icon">
                                                        <use href={`/img/sprite-icons.svg#${showPassword ? 'eye-slash-fill' : 'eye-fill'}`} />
                                                    </svg>
                                                </button>
                                            </div>
                                        </label>
                                    </div>

                                    <div style={{ paddingLeft: '0'}} className="form__col">
                                        <label className="input__label input-label">Подтвердите пароль</label>
                                        <label className="text-input">
                                            <input
                                                className="text-input__input"
                                                placeholder="Повторите пароль"
                                                type={showConfirm ? 'text' : 'password'}
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                required
                                            />
                                            <div className="text-input__control">
                                                <button
                                                    type="button"
                                                    className="text-input__icon text-input__password-toggle"
                                                    onClick={() => setShowConfirm((v) => !v)}
                                                >
                                                    <svg className="svg-icon">
                                                        <use href={`/img/sprite-icons.svg#${showConfirm ? 'eye-slash-fill' : 'eye-fill'}`} />
                                                    </svg>
                                                </button>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset className="form__submit">
                                <div className="profile-page__save">
                                    <button className="profile-page__save-link pointer" type="submit">
                                        Сохранить
                                    </button>
                                </div>
                            </fieldset>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PasswordTab;
